export const getNotificationImportance = (length: number): 'High' | 'Medium' | 'Low' => {
  if (length > 500) return 'High';
  if (length > 200) return 'Medium';
  return 'Low';
};

export const IMPORTANCE_TEXT_CLASSES: Record<'High' | 'Medium' | 'Low', string> = {
  High: 'text-red-600 font-semibold',
  Medium: 'text-yellow-600 font-medium',
  Low: 'text-green-600',
};
